<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>入库管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.shangpinfenlei" @keyup.enter.native="clickSearch" placeholder="请输入商品分类"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.shangpinname" @keyup.enter.native="clickSearch" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch">查询</el-button>
            <el-button type="primary" @click="clickexcel()" v-if="SubRule_Erp6Inventory_ExcelIn">导出Excel</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
          <el-table-column prop="Riqi" label="日期" width="110"></el-table-column>
          <el-table-column prop="Orderid" label="合同编号" width="160"></el-table-column>
          <el-table-column prop="ZileiName" label="入库类别" width="120"></el-table-column>
          <el-table-column prop="Shangpinfenlei" label="商品分类" width="100"></el-table-column>
          <el-table-column prop="Shangpinname" label="商品名称" width="200"></el-table-column>
          <el-table-column prop="Shangpincode" label="商品编码" width="200"></el-table-column>
          <el-table-column prop="Shangpinguige" label="商品规格" width="300"></el-table-column>
          <el-table-column prop="Shangpinunit" label="单位" width="100"></el-table-column>
          <el-table-column prop="Num" label="数量" width="100"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" width="300"></el-table-column>
          <el-table-column prop="operation" label="操作" width="120" fixed="right">
            <template v-slot="scope">
              <el-button v-if="scope.row.Zilei != 100" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.Zilei != 100" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加入库" name="three">
      <el-form :model="addForm" ref="addForm" label-width="170px">
        <el-form-item class="addAdminForm" label="入库类别">
          <el-select v-model="addForm.zilei" placeholder="请选择">
            <el-option label="生产完工入库" value="101"></el-option>
            <el-option label="退货入库" value="105"></el-option>
            <el-option label="返修入库" value="102"></el-option>
            <el-option label="体验产品入库" value="103"></el-option>
            <el-option label="其他入库" value="104"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="产品名称">
          <el-select v-model="addForm.projectcode" placeholder="请选择" filterable>
            <el-option
              v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="日期">
          <el-date-picker v-model="addForm.riqi" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item class="addAdminForm" label="数量">
          <el-input v-model="addForm.num"></el-input>
        </el-form-item>
        <el-form-item label="备注(选填)" class="addAdminForm">
          <el-input v-model="addForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="apiAddErp6InventoryIn">添加</el-button>
          <el-button type="info" @click="clickReturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- start -->
    <el-tab-pane label="修改入库" name="five" disabled="disabled">
      <Erp6InventoryInEdit ref="SubVuefive" v-on:triggerFunc="BackToFirst"></Erp6InventoryInEdit>
    </el-tab-pane>
    <!-- end -->

  </el-tabs>
  </div>
</template>

<script>
import Erp6InventoryInEdit from '@/componentsSubVue/Erp6InventoryInEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Erp6InventoryInEdit
  },
  name: 'MyErp6InventoryIn',
  data () {
    return {
      activeName: 'first',
      ProjectNameList:[],
      addForm: {
        zilei: '',
        projectcode: '',
        riqi: '',
        num: '',
        beizhu: ''
      },
      // 查询
      keywords: {
        shangpinfenlei: '',
        shangpinname: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      SubRule_Erp6Inventory_ExcelIn: false,
    }
  },
  mounted () {
    this.apiGetErp6ProjectNameList()
    this.apiGetErp6InventoryInNum()
    this.apiGetErp6InventoryInList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Erp6Inventory_ExcelIn', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6Inventory_ExcelIn = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6InventoryInNum()
      this.apiGetErp6InventoryInList()
    },
    clickedit (row) {
      var that = this
      that.activeName = 'five'
      that.$refs.SubVuefive.LoadData(row,this.ProjectNameList)
    },
    clickReturn () {
      this.activeName = 'first'
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp6InventoryIn(row.Id)
      })
    },
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6InventoryInNum()
      this.apiGetErp6InventoryInList()
    },
    clickexcel () {
      this.apiExcelErp6InventoryIn()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6InventoryInList()
    },
    //为下拉框获取数据源-项目名称
    apiGetErp6ProjectNameList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: '',
        code: '',
        classification: ''
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6ProjectNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.ProjectNameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetErp6InventoryInNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6InventoryInNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6InventoryInList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6InventoryInList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6InventoryIn: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        zilei: that.addForm.zilei,
        projectcode: that.addForm.projectcode,
        riqi: that.addForm.riqi,
        num: that.addForm.num,
        beizhu: that.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6InventoryIn, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6InventoryInNum()
            that.apiGetErp6InventoryInList()

            // 清空添加
            that.addForm.zilei = ''
            that.addForm.projectcode = ''
            that.addForm.riqi = ''
            that.addForm.num = ''
            that.addForm.beizhu = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp6InventoryIn: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp6InventoryIn, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6InventoryInNum()
            that.apiGetErp6InventoryInList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelErp6InventoryIn: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErp6InventoryIn, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
